import { render, staticRenderFns } from "./AOAP.vue?vue&type=template&id=117c0f0c&scoped=true&"
import script from "./AOAP.vue?vue&type=script&lang=js&"
export * from "./AOAP.vue?vue&type=script&lang=js&"
import style0 from "./AOAP.vue?vue&type=style&index=0&id=117c0f0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c0f0c",
  null
  
)

export default component.exports